// axios
import axios from 'axios'

//export const baseURL = "http://api.rinjani.healtri.com/rinjani/api/"
//export const baseURL = "https://api-helix.healtri.com/helix/"
//const baseURL = "https://lisv2.healtri.com/rsdcwav2/api/"
const baseURL = "https://be-lis.indotelemed.web.id/trijaya/api/"
//const baseURL = "http://lisapi.dolphins.software/dolphinlis/api/"

export const init = () => {
    return axios.create({
      baseURL: baseURL
      // You can add your headers here
  });
};

export const setAuthorizationHeader = (instance) => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    if(user) {
        const accessToken = user.token;

        // Set the AUTH token for any request
        instance.interceptors.request.use(function (config) {
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            } else {
                //localStorage.removeItem("userInfo");
                window.location.href = '/pages/logout';
            }
            return config;
        });

        instance.interceptors.response.use(function (response) {
            //console.log('response :'+JSON.stringify(response))
            /*if (response.data && !response.data.status) {
                window.location.href = '/pages/login';
                return Promise.reject(response.data.message);
            }*/

            return response;
        }, function (error) {
          console.log('error response :'+error.response)
            if (error.response && (401 === error.response.status)) {
                localStorage.clear();
                window.location.href = '/pages/logout';
            } /*else {
                window.location.href = '/pages/error-404';
                return Promise.reject(error);
            }*/
        });
    }

    return instance;
};
